var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 311,
    viewBox: "-4 -4 311 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_map)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.594 0H151.5V303H274.594C290.217 303 303 290.217 303 274.594V28.4062C303 12.7828 290.217 0 274.594 0Z",
    fill: "#CC0808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4062 0C12.7828 0 0 12.7828 0 28.4062V274.594C0 290.217 12.7828 303 28.4062 303H151.5V0H28.4062Z",
    fill: "#E2A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.677 295.311C196.041 295.311 192.405 293.929 189.631 291.154L176.242 277.765C170.693 272.217 170.693 263.231 176.242 257.682C181.79 252.134 190.776 252.134 196.325 257.682L209.714 271.071C215.263 276.62 215.263 285.606 209.714 291.154C206.939 293.919 203.313 295.311 199.677 295.311ZM144.389 245.913H125.451C117.602 245.913 111.248 239.55 111.248 231.709C111.248 223.869 117.602 217.506 125.451 217.506H144.389C152.239 217.506 158.592 223.869 158.592 231.709C158.592 239.55 152.239 245.913 144.389 245.913Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4726 46.9922L74.0078 94.6863H18.9375L46.4726 46.9922ZM70.3907 56.8113H125.461L97.9258 9.11719L70.3907 56.8113Z",
    fill: "#CC0808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.527 122.742L284.062 170.436H228.992L256.527 122.742Z",
    fill: "#E2A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.784 166.621C63.6772 170.361 72.3033 167.833 76.0529 160.939C78.742 156.016 81.8004 151.3 85.1524 146.926C89.9151 140.705 88.741 131.776 82.5106 127.013C76.2896 122.231 67.3701 123.415 62.5978 129.645C58.3558 135.184 54.4926 141.14 51.1122 147.342C47.3531 154.236 49.9002 162.862 56.784 166.621Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.337 65.2974C200.501 65.7046 193.939 66.2822 187.652 67.0491C179.859 67.9865 174.301 75.0502 175.238 82.843C176.1 90.0582 182.235 95.3512 189.318 95.3512C189.318 95.3512 201.268 94.1108 209.023 93.6468C216.853 93.1829 222.828 86.4601 222.364 78.6294C221.9 70.8082 215.177 64.7388 207.337 65.2974Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.154 81.1373C122.677 83.675 116.39 86.544 110.481 89.6781C103.56 93.3615 100.918 101.95 104.592 108.881C107.148 113.691 112.063 116.427 117.157 116.427C121.759 116.427 127.582 112.252 139.503 107.593C146.804 104.733 150.411 96.4956 147.561 89.1952C144.692 81.8854 136.483 78.3156 129.154 81.1373Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4254 231.984L99.829 214.581C105.595 208.814 105.595 199.469 99.829 193.702C94.0625 187.936 84.7074 187.936 78.9504 193.702L61.5468 211.106L44.1433 193.702C42.0128 191.572 39.3521 190.502 36.6156 189.943C31.9286 188.987 26.9007 190.066 23.2647 193.702C17.4982 199.469 17.4982 208.814 23.2647 214.581L40.6682 231.984L23.2647 249.388C17.4982 255.154 17.4982 264.5 23.2647 270.267C26.1432 273.155 29.9212 274.594 33.6992 274.594C37.4773 274.594 41.2648 273.155 44.1433 270.267L61.5468 252.863L78.9504 270.267C81.8384 273.155 85.6164 274.594 89.3944 274.594C93.1725 274.594 96.9505 273.155 99.8384 270.267C105.605 264.5 105.605 255.154 99.8384 249.388L82.4254 231.984Z",
    fill: "#CC0808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.283 8.08631L199.904 27.0143C199.743 34.8545 205.974 41.35 213.814 41.5015C213.918 41.5015 214.013 41.5015 214.107 41.5015C221.815 41.5015 228.149 35.3279 228.301 27.5825L228.68 8.65444C228.746 5.41612 227.676 2.43347 225.886 0H203.01C201.353 2.26303 200.349 5.02791 200.283 8.08631Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_map",
    x: -4,
    y: 0,
    width: 311,
    height: 311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.db759ed36d96a03847aed753d9a83350.svg";
export { ForwardRef as ReactComponent };